<div class="{{tabClass}}" *ngIf="active" @tabChange>
  <ng-content></ng-content>
</div>
